import authAxios from "../common/authAxios";

class AchievementInfoService {
    getAchievements() {
        return authAxios.get("/achievement-info/");
    }

    saveAchievement(data) {
        return authAxios.post("/achievement-info/save-achievement-info", data);
    }
}
export default AchievementInfoService;